import { authState } from '../config/ids';
import type { AuthState } from './types/AuthState';

export const setAuthState = (state: AuthState): void =>
  localStorage.setItem(authState, JSON.stringify(state));
